<template>
    <div class="choice">
        <div class="row" v-if="showButtons" :class="{'is-invalid': errors.length}">
            <div v-for="(item, key) in dataForButtons" :key="key" class="col-6 col-sm-4 mb-4">
                <button
                    class="btn btn-outline-info btn-block btn-lg d-flex flex-column h-100 align-items-center justify-content-center  py-2"
                    @click="selectedItem = item"
                    :class="{'btn-info-gradient' : selectedItem.id === item.id, 'py-3' : showButtonDescription || showButtonImages}">
                    <span v-if="showButtonTitle && item.title"
                          :class="{'font-weight-bolder' : (showButtonTitle && showButtonDescription) }">{{ item.title }}</span>
                    <span v-if="showButtonDescription && item.description">{{ item.description }}</span>
                    <img v-if="showButtonImages && item.image" :src="item.image" alt="" class="img-fluid">
                </button>
            </div>
        </div>
        <div class="row" v-if="showSelectControl" :class="{'is-invalid': errors.length}">
            <div class="col-12">
                <div class="form-group">
                    <select v-model="selectedItem" class="custom-select custom-select-lg w-100"
                            :class="{ 'mt-4' : showButtons }">
                        <option :value="{}">{{ selectPlaceholder }}</option>
                        <option v-for="(item, key) in data" :key="key" :value="item" :disabled="item.disabled">
                            {{ item.title }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        
        <slide-y-up-transition>
            <div class="invalid-feedback mb-4" v-if="errors.length">
                <span v-for="(error,k) in errors" :key="k">
                    {{ error }}
                </span>
            </div>
        </slide-y-up-transition>
    </div>
</template>

<script>
import {SlideYUpTransition} from 'vue2-transitions';

const _ = require('../../utils/lodash').default;

export default {
    name: "Choice",
    components: {SlideYUpTransition},
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: [String, Number],
        data: Array,
        buttonsData: Array,
        errors: {
            type: Array,
            default: () => [],
        },
        showButtons: {
            type: Boolean,
            default: true,
        },
        showButtonImages: Boolean,
        showButtonTitle: Boolean,
        showButtonDescription: Boolean,
        showSelectControl: Boolean,
        selectPlaceholder: String,
    },
    data: function () {
        return {
            selectedItem: {},
        }
    },
    computed: {
        dataForButtons: function () {
            return this.buttonsData || this.data
        }
    },
    created() {
        if (this.value) {
            let that = this;
            _.each(this.data, function (value) {
                if (value.id === that.value) {
                    that.selectedItem = value;
                }
            })
        }
    },
    watch: {
        selectedItem: function (newValue) {
            this.$emit('update:errors', []);
            this.$emit('update', newValue.id);
        },
        value: function (newValue) {
            let that = this;
            if (newValue === null) {
                that.selectedItem = {}
            }
            _.each(this.data, function (value) {
                if (value.id === newValue) {
                    that.selectedItem = value;
                }
            });
        },
        data: function (newValue) {
            let that = this;
            _.each(newValue, function (value) {
                if (value.id === that.value) {
                    that.selectedItem = value;
                }
            });
        }
    },
    
}
</script>

<style scoped lang="scss">
button {
    min-height: 50px;
    max-height: 81px;
    
    &.btn-info-gradient {
        img {
            filter: brightness(0) invert(1);
        }
    }
}
</style>
